"use client";

import React from "react";
import Footer from "../../../components/common/Footer";
import Header from "../../../components/common/Header";
import { TermsAndConditionsCommon } from "../../../components/common/TermsAndConditions/TermsAndConditionsCommon";
import { useTranslations, useLocale } from "next-intl";
import { useTenantBranding } from "@/app/context/TenantBrandingContext";
import type { LocalizedText } from "@/app/api/utils/types/tenants";
import sanitizeHtml from "sanitize-html";

function getLocalizedText(text: LocalizedText | undefined, locale: string): string {
  if (!text) return "";
  return text[locale as keyof LocalizedText] || text.en || "";
}

export default function TermsAndConditions() {
  const t = useTranslations();
  const locale = useLocale();
  const { policies } = useTenantBranding();

  const tenantContent = getLocalizedText(policies?.termsConditions, locale);

  return (
    <div className="flex min-h-screen flex-col bg-white dark:bg-sleap-gray-950">
      <Header />
      <main className="flex-grow py-4 sm:py-4 md:py-16 lg:pt-6 lg:pb-24">
        <div className="mx-auto max-w-6xl px-4 sm:px-4 md:px-6">
          <section className="p-4 flex flex-col gap-6">
            <h1 className="text-3xl font-bold font-switzer leading-loose text-zinc-900 dark:text-white sm:text-2xl lg:text-4xl">
              {t("Footer.termsAndConditions")}
            </h1>
            {tenantContent ? (
              <div
                className="prose prose-zinc dark:prose-invert max-w-none w-full font-switzer text-base leading-relaxed"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(tenantContent) }}
              />
            ) : (
              <TermsAndConditionsCommon />
            )}
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
